import { render, staticRenderFns } from "./EliminaDestino.vue?vue&type=template&id=4f153122&scoped=true"
import script from "./EliminaDestino.vue?vue&type=script&lang=js"
export * from "./EliminaDestino.vue?vue&type=script&lang=js"
import style0 from "./EliminaDestino.vue?vue&type=style&index=0&id=4f153122&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f153122",
  null
  
)

export default component.exports